// api/brandApi.ts
import { baseApi } from './baseApi';

const categoryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    categoryData: build.query({
      query: () => ({
        url: '/service',
        method: 'GET',
      }),
      providesTags: ['category'],
    }),
    categoryDetails: build.query({
      query: (categoryId) => ({
        url: `/service/${categoryId}`,
        method: 'GET',
      }),
      providesTags: ['category'],
    }),
    deleteCategory: build.mutation({
      query: (brandId) => ({
        url: `/service/${brandId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['category'],
    }),
  }),
});

export const {
  useCategoryDataQuery,
  useDeleteCategoryMutation,
  useCategoryDetailsQuery,
} = categoryApi;
